import React, { createContext } from 'react'

const RelationshipCalculatorContext = createContext()

const initialRelCalculatorContext = {
  insetInlineStart: {
    prefix: '',
    inputId: '',
    validId: false,
    personId: '',
    side: 'left',
  },
  insetInlineEnd: {
    prefix: '',
    inputId: '',
    validId: false,
    personId: '',
    side: 'right',
  },
  includeSpouses: true,
  summary: true,
}

const RelationshipCalculatorProvider = ({ value, children }) => (
  <RelationshipCalculatorContext.Provider value={value}>{children}</RelationshipCalculatorContext.Provider>
)

export default RelationshipCalculatorProvider
export { RelationshipCalculatorContext, initialRelCalculatorContext }
